export default __webpack_public_path__ + "static/media/add.37e3525e.svg";